import DefaultInstance from "@/instance/axios";
import { createMutationKeys } from "@lukemorales/query-key-factory";
import { DefaultApiWmsOutsourceInventoryLogPostRequest } from "@sizlcorp/sizl-api-document/dist/models";

export const outsource = createMutationKeys("outsource", {
  inventoryLog: (params: DefaultApiWmsOutsourceInventoryLogPostRequest) => {
    return {
      mutationKey: [params.wmsOutsourceInventoryLogPostRequest],
      mutationFn: () => DefaultInstance.wmsOutsourceInventoryLogPost(params),
    };
  },
});
